import React, { Component } from 'react'
import style from './style.css'

export default class Textarea extends Component {
    render() {
        let { handleChange, ...other } = this.props

        return (
            <div className={style.boxField} style={this.props.style || {}}>
                <label>
                    <textarea
                        { ...other }
                        className={`${style.text} ${style.textarea} ${(this.props.transparent) ? style.transparent : ''} ${this.props.className || ''}`}
                        placeholder={this.props.placeholder || ' '}
                        onChange={this.props.handleChange}
                        name={this.props.name || ''}
                        disabled={(this.props.disabled) ? 'disabled' : ''}
                        style={{
                            ...this.props.style,
                            height: this.props.height || '80px',
                        }}
                        />
                        {
                            (this.props.error)
                            ? <span className={style['error-icon']}>&#9888;</span>
                            : ''
                        }
                        {
                            (this.props.error)
                            ? <span className={style.error}>{this.props.error}</span>
                            : ''
                        }
                        {this.props.label && (
                            <span className={style.placeholderFloat}>
                                <span className={style.placeholderFloatText}>{this.props.label}</span>
                                <hr className={style.lineWhite} />
                            </span>
                        )}
                </label>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Forms/textarea.js